export const useInitializeStartupTasks = async () => {
  if (process.server) return;

  // const { initializeDictionaryData } = useSpellChecker();
  // await initializeDictionaryData();

  const { initializeAppUserData, initializeUserClaims } = useAppUserDataStore();

  await initializeAppUserData();

  useUserDocumentsStore().initialize();

  const userClassroomsStore = useUserClassroomsDataStore();
  userClassroomsStore.initialize();

  await initializeUserClaims();

  const { initializeIEWProductCategories } = useIEWProductCategories();
  initializeIEWProductCategories();

  const { initializeLevels } = useLevels();
  initializeLevels();

  const { initializeLessons } = useLessons();
  initializeLessons();

  const { streamComments } = useSystemCommentsStore();
  streamComments();

  const { initializeAnnotationTypes } = useAnnotationTypesStore();
  initializeAnnotationTypes();

  useRemoteConfig().activate();

  useApplicationCapabilityCategories().initialize();

  const guidedTourStore = useGuidedTours();
  guidedTourStore.streamAllTours();

  const sampleDocumentsStore = useSampleDocuments();
  sampleDocumentsStore.streamSampleDocuments();

  await useCapabilitiesServiceStore().initialize();

  useUserChecklistsStore().initializeChecklists();
};
